import Carousel from 'react-bootstrap/Carousel';

const Slider = () => {
    return (
        <Carousel className='mt-5'>
            <Carousel.Item>
                <img className='d-block w-100 h-25 carousel-image' src={`${process.env.PUBLIC_URL}/assets/banner2.jpg`} alt="banner" />
                <Carousel.Caption>
                    {/* <h3>First slide label</h3>
                    <p className='carousel-dec'>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> */}
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
            <img className='d-block w-100 h-25 carousel-image' src={`${process.env.PUBLIC_URL}/assets/banner3.jpg`} alt="banner" />
                <Carousel.Caption>
                    {/* <h3>Second slide label</h3>
                    <p className='carousel-dec'>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> */}
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
            <img className='d-block w-100 h-25 carousel-image' src={`${process.env.PUBLIC_URL}/assets/bannerone.jpg`} alt="banner" />
                <Carousel.Caption>
                    {/* <h3>Third slide label</h3>
                    <p className='carousel-dec'>
                        Praesent commodo cursus magna, vel scelerisque nisl consectetur.
                    </p> */}
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    )
}

export default Slider